import { connect } from 'react-redux'
import ProviderTripsManagement from '../../components/trips/management/ProviderTripsManagement'
import {
  actionCreators,
  assignMultipleOperator,
  cancelMultipleOperator,
  manualCompleteTrip,
  getTripById,
  getManyTrips,
  optimizeRoute,
  optimizeTrip
} from '../../state/actions/trips/index'
import {
  IStoreState,
  ITripFilters,
  IActiveTripResponseV2,
  ISimpleDriverDTO,
  IManualCompleteTripState,
  IScheduledRequestedTripsFiltersDTO,
  IUpdateOptimizedTripsDTO,
  IServiceListFilterDTO
} from '../../types/index'
import * as actions from '../../state/actions/trips'
import { getDriversList } from '../../state/actions/drivers'
import { TripStatuses } from 'src/constants/trip-statuses'
import { ManualTripGroupRidesDTO } from 'src/types/trip-group-rides'
import * as tripActions from '../../state/actions/trips'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    orgId: state.organizations.currentOrgId,
    productIds: state.providerProduct.currentProductIds,
    selectedRows: state.trips.selectedRows,
    operators: Object.values(state.drivers.items),
    summaryFilters: state.trips.summaryFilters,
    getAllTrips: state.trips.summaryItems,
    products: Object.values(state.providerProduct.items),
    services: Object.values(state.service.items),
    optimizeRouteResponse: state.trips.optimizeRouteResponse,
    optimizeTripResponse: state.trips.optimizeTripResponse
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    getTripById: (tripId: string) => {
      return dispatch(actions.getTripById(tripId))
    },
    fetchOperators: (organizationId: string) => {
      return dispatch(
        getDriversList({
          organizationId,
          skip: 0,
          take: 1000
        })
      )
    },
    assignMultipleOperator: (trip: string[], operator: ISimpleDriverDTO) => {
      return dispatch(assignMultipleOperator(trip, operator))
    },
    cancelMultipleOperator: (trip: string[], comment: string) => {
      return dispatch(cancelMultipleOperator(trip, comment))
    },
    manualCompleteTripOperator: (trip: string[], comment: string, data: IManualCompleteTripState) => {
      return dispatch(manualCompleteTrip(trip, comment, data))
    },
    updateTripDriver: () => dispatch(actionCreators.updateTripDriver()),

    optimizeRoute: (request: IScheduledRequestedTripsFiltersDTO) => dispatch(optimizeRoute(request)),
    optimizeTrip: (request: IUpdateOptimizedTripsDTO) => dispatch(optimizeTrip(request)),
    groupScheduledTrips: async (param: ITripFilters) => {
      return dispatch(actions.groupRideRequestedScheduledTrips(param))
    },
    manual: (request: ManualTripGroupRidesDTO) => {
      return dispatch(actions.manual(request))
    },
    unGroupScheduledTrips: async (param: ITripFilters) => {
      return dispatch(actions.unGroupRideRequestedScheduledTrips(param))
    },
    getScheduledRequestedTrips: (params: IScheduledRequestedTripsFiltersDTO) =>
      dispatch(tripActions.getScheduledRequestedTrips(params))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderTripsManagement)



// WEBPACK FOOTER //
// ./src/containers/trips/ProviderTripsManagement.ts